import { Button, Paper } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import React from "react";
import { ISchedule } from "../../../interfaces";
import SummaryImage from "../../shared/SummaryImage/SummaryImage";
import "./MyScheduleSummaryBlock.scss";
import translate from "../../../i18n/translate";
import { scheduleCourseStatus } from "../../../globalConstants";

const MyScheduleSummaryBlock: React.FC<ISchedule> = ({
  Heading,
  Description,
  IsAddButtonRequired,
  HeaderTextColor,
  PaperOnClick,
  ScheduleOnClick,
  imageURL,
  buttonClick,
  courseStatus
}) => {
  const statusHelper = ()=> {
    if(!!courseStatus)
    return translate("myschedule_status_"+ Object.values(scheduleCourseStatus).filter(allStatus => Number(allStatus.status) === Number(courseStatus))[0].statusString.toLowerCase().replace(" ",""));
  };
  return (
    <div className="RM-card-header">
      <Paper className="RM-card-container" onClick={PaperOnClick}>
        <div className={"RM-tutorial-image-container " + HeaderTextColor}>{Heading}</div>
        <div className="RM-course-title RM-course-title-schedule">
          <p className={ typeof(imageURL)!=="undefined"? "session-status-home" : "session-status-open"}>
            {Description}
            {IsAddButtonRequired &&
            <span className="jss783" aria-label="schedule a session" role="button">
               <AddCircleIcon aria-hidden="false"  role="button" tabIndex={0} aria-label="schedule new session"  className="jss787" onClick={ScheduleOnClick}></AddCircleIcon>
            </span>
            }
          </p>
          { imageURL!==null &&
           typeof(imageURL)!=="undefined" && <SummaryImage customClass={"session-image-home"} alt="Sprint-Image" url={imageURL || ""} height={"140"} width={"120"}></SummaryImage> }
        </div>
        { imageURL!==null && typeof(imageURL)!=="undefined" &&
        <div className="course-status">
        <b>{translate("SessionRating_status")}</b>
         </div> 
        }
         <div>
         { imageURL!==null && typeof(imageURL)!=="undefined" && <label className="course-lbl">{statusHelper()}
         </label>}
         </div>
        {imageURL!==null && typeof(imageURL)!=="undefined" && <Button color="primary" variant="contained" size="medium" onClick={buttonClick} className="session-view-button">{translate("myschedule_homepage_view")}</Button>}
      </Paper>
    </div>
  );
};

export default MyScheduleSummaryBlock;
